import {z} from '@hono/zod-openapi';

/** Shared shape for "parse a file already uploaded via the storage module" requests. */
export const hondaStorageFileRequestSchema = z
  .object({
    fileId: z.string().min(1).openapi({example: 'a1b2c3d4-...'}),
    fileName: z.string().min(1).openapi({example: 'KAMP260211.xml'}),
  })
  .openapi('HondaStorageFileRequest');

export type HondaStorageFileRequest = z.infer<typeof hondaStorageFileRequestSchema>;
